var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigmaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.93 219.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e9a18b;}.cls-2{fill:#f8f8f8;}.cls-3{fill:#1e1b19;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 34") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_17_copy",
    "data-name": "Layer 17 copy"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.12,
    y: 13.12,
    width: 193.7,
    height: 193.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85,85.06h25a0,0,0,0,1,0,0v49.75a0,0,0,0,1,0,0H85a24.87,24.87,0,0,1-24.87-24.87v0A24.87,24.87,0,0,1,85,85.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85,134.79h25a0,0,0,0,1,0,0v24.87a24.87,24.87,0,0,1-24.87,24.87H85a24.87,24.87,0,0,1-24.87-24.87v0A24.87,24.87,0,0,1,85,134.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85,35.4h25a0,0,0,0,1,0,0V85.15a0,0,0,0,1,0,0H85A24.87,24.87,0,0,1,60.14,60.27v0A24.87,24.87,0,0,1,85,35.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.84,35.4h25a0,0,0,0,1,0,0V85.15a0,0,0,0,1,0,0h-25A24.87,24.87,0,0,1,110,60.27v0A24.87,24.87,0,0,1,134.84,35.4Z",
    transform: "translate(269.76 120.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 109.97,
    y: 85.15,
    width: 49.83,
    height: 49.75,
    rx: 24.87,
    transform: "translate(269.76 220.05) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.18,17a8.76,8.76,0,0,1,8.75,8.75V194.18a8.75,8.75,0,0,1-8.75,8.75H25.75A8.76,8.76,0,0,1,17,194.18V25.75A8.77,8.77,0,0,1,25.75,17H194.18m0-17H25.75A25.75,25.75,0,0,0,0,25.75V194.18a25.75,25.75,0,0,0,25.75,25.75H194.18a25.75,25.75,0,0,0,25.75-25.75V25.75A25.75,25.75,0,0,0,194.18,0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaIcon);
export default __webpack_public_path__ + "static/media/Figma--icon.8e94113a40946f53f5bc96ffe63b1478.svg";
export { ForwardRef as ReactComponent };